// extracted by mini-css-extract-plugin
export var alertIcon = "_po-0";